const LiveBlog = (function () {
	let container;
	let postId;
	let lastUpdated = 0;
	let updateButton;

	function checkForUpdate() {
		const params = new URLSearchParams({
			action: "live_blog_status",
			post_id: postId,
			nonce: liveBlogData.nonce,
		});

		fetch(`${liveBlogData.ajax_url}?${params.toString()}`)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					if (data.data.last_updated > lastUpdated) {
						lastUpdated = data.data.last_updated;
						fetchLiveBlog();
					}
				}
			})
			.catch((error) => console.error("Status check failed", error));
	}

	function fetchLiveBlog() {
		const params = new URLSearchParams({
			action: "refresh_live_blog",
			post_id: postId,
			nonce: liveBlogData.nonce,
		});

		fetch(`${liveBlogData.ajax_url}?${params.toString()}`)
			.then((response) => response.text())
			.then((html) => {
				container.innerHTML = html;
			})
			.catch((error) => console.error("Live blog fetch error:", error));
	}

	return {
		init: function () {
			container = document.getElementById("live-blog-container");
			if (!container) return;

			if (container.getAttribute("data-blog-type") === "sumarizovany_clanok") {
				return;
			}

			postId = container.getAttribute("data-post-id");
			lastUpdated = parseInt(container.getAttribute("data-last-updated")) || 0;

			setInterval(checkForUpdate, 60000);

			updateButton = document.querySelector(".update-live-blog");
			if (updateButton) {
				updateButton.addEventListener("click", checkForUpdate);
			}
		}
	};
})();

export default LiveBlog;

document.addEventListener("DOMContentLoaded", () => {
  LiveBlog.init();
});